<footer class="footer" id="footer">
  <div class="custom-container">
    <div class="flex flex-col md:flex-row md:gap-32">
      <div class="flex flex-col gap-3 pr-0 md:pr-8 pb-7 md:pb-0">
        <h1 class="footer__title">{{ 'menu.realy_about_us' | translate }}</h1>
        <a class="footer__smoke-link">{{ 'menu.news' | translate }}</a>
        <a class="footer__smoke-link whitespace-nowrap">{{ 'menu.about_us' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.partners' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.client_reviews' | translate }}</a>
      </div>

      <div class="flex flex-col gap-3 pr-0 md:pr-8 pb-7 md:pb-0">
        <h1 class="footer__title">{{ 'menu.faq' | translate }}</h1>
        <a class="footer__smoke-link">{{ 'menu.how_it_work' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.faq_long' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.verification_guide' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.referal_program' | translate }}</a>
      </div>

      <div class="flex flex-col gap-3 pr-0 md:pr-8 pb-7 md:pb-0">
        <h1 class="footer__title">{{ 'menu.legal_info' | translate }}</h1>
        <a class="footer__smoke-link cursor-pointer" (click)="openEula()">
          {{ 'menu.eula_info' | translate }}
        </a>
        <a class="footer__smoke-link">{{ 'menu.aml_policy' | translate }}</a>
        <a class="footer__smoke-link cursor-pointer" (click)="getAgreementInfo()">
          {{ 'menu.user_agreement' | translate }}
        </a>
        <a class="footer__smoke-link">{{ 'menu.refund_policy' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.cookie_policy' | translate }}</a>
        <a class="footer__smoke-link" href="https://napp.uz/storage/files/shares/licences/CS0010.pdf">
          {{ 'menu.service_license' | translate }}
        </a>
      </div>

      <div class="flex flex-col gap-3 pr-0 md:pr-8 pb-7 md:pb-0">
        <h1 class="footer__title">{{ 'menu.support' | translate }}</h1>
        <a class="footer__smoke-link">{{ 'menu.support_center' | translate }}</a>
        <a class="footer__smoke-link">{{ 'menu.feedback' | translate }}</a>
      </div>



      <div class="flex flex-col gap-3 pr-0 md:pr-8 pb-7 md:pb-0 text-start">
        <p class="footer__smoke-link" [innerHTML]="'about.license_text' | translate | safeHtml">
        </p>
        <p class="text-center md:text-left">{{ 'public.developed_by' | translate }}
          <a class="underline" href="" target="_blank">
            AnoteraDev
          </a>
        </p>
      </div>
    </div>

    <div class="h-[2px] bg-[#1212121A] mt-8"></div>

    <div class="flex flex-col md:flex-row justify-between items-center mt-4">
      <img src="images/logos/logo.svg" width="150" height="38" class="logo inline-block h-auto mx-1" alt="logo">


      <div class="flex flex-col md:flex-row gap-8">
        <span class="inline-block text-center mt-8 md:mt-1 text-[#12121280]">+998 55 500 40 20</span>

        <div class="flex flex-row gap-8 md:gap-4">
          <a href="https://www.instagram.com/tcryptouzb" target="_blank" rel="noopener">
            <img src="images/icons/social/instagram.svg" width="32" height="32" class="logo inline-block h-auto mx-1"
              alt="instagram">
          </a>
          <a href="https://www.facebook.com/tcryptouzb" target="_blank" rel="noopener">
            <img src="images/icons/social/facebook.svg" width="32" height="32" class="logo inline-block h-auto mx-1"
              alt="facebook">
          </a>
          <a href="https://t.me/tcryptouz" target="_blank" rel="noopener">
            <img src="images/icons/social/telegram.svg" width="32" height="32" class="logo inline-block h-auto mx-1"
              alt="telegram">
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>